/**
 * Unified analytics API.
 *
 * Usage:
 *   import { analytics } from '../analytics';
 *   analytics.track(BOOKING_STARTED, { service_slug: 'plumbing' });
 */
import { initAmplitude, trackEvent } from "./amplitude";
import { initClarity, setClarityTag } from "./clarity";
import {
  identifyAnalyticsUser,
  resetAnalyticsUser,
  updateAnalyticsUserProperties,
} from "./identify";

export { usePageTracking } from "./usePageTracking";
export * from "./events";

/**
 * Initialize all analytics SDKs. Call once at app startup.
 */
export function initAnalytics() {
  initAmplitude();
  initClarity();
}

export const analytics = {
  track: trackEvent,
  identify: identifyAnalyticsUser,
  reset: resetAnalyticsUser,
  setUserProperties: updateAnalyticsUserProperties,
  setClarityTag,
};
